/**
 *
 * Asynchronously loads the component for HallticketPreview
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const HallticketPreview = lazyLoad(
  () => import('./index'),
  module => module.HallticketPreview,
);
